import React from "react";
import { useTranslation } from "react-i18next";
import "./subtitlePageHL.css";
import { useRef } from "react";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";

//Image to use as default profile image
// import {profileIconDefault} from "../../../assets/logos/icons";

const SubtitlePageHLPure = (props) => {
  const {
    subtitle, //Text subtitle
    imgProfile, //Image default
    uploadFile, //Function change img
    profileImg, //Choose your image
    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon
    altCustomImg, //Alt to custom image
    changeImgFile, //Function to change image
    justShowImg, // true or false, true if you just show the image and false if you need to use the onChange functions
    openTooltipDescription, //True to open description tooltip or false to close.
    typeBox, //true or false if header has a box or false if has only a line
    imageFromPc, //if want to search an image from Pc,
    moreIcos, //add icons 
    textRight, // true or false and add more text
    subtitleRight, // add more text 
    statusContract, //text status contract
    colorStatusContract //color of text status contract
  } = props;
  const { t } = useTranslation();

  //Function change image
  // handleImage = async (e) => {
  //   if (e.target.files && e.target.files[0]) {
  //     if (e.target.files[0].size < 4194304) {
  //       let reader = new FileReader();
  //       reader.onload = async (e) => {
  //         this.setState({
  //           userPathImage: e.target.result,
  //         });
  //         await this.localStorageService.setLocalStorageItem(
  //           "newImage",
  //           e.target.result
  //         );
  //       };
  //       reader.readAsDataURL(e.target.files[0]);
  //       this.setState({
  //         userImage: e.target.files[0],
  //       });
  //       let updateFile = new FormData();
  //       updateFile.append("file", e.target.files[0]);
  //       await this.userDocService.getUserDocProfile(updateFile, this.token);
  //     } else {
  //       this.setState(
  //         {
  //           showErrorRequesting: true,
  //           message: this.props.t("dialogUpdateUserAddress.ImageError"),
  //         },
  //         () => {
  //           setTimeout(() => {
  //             this.setState({ showErrorRequesting: false });
  //           }, 4000);
  //         }
  //       );
  //     }
  //   }
  // };

  // const uploadFile = (ref) => ref.current.click();
  const imageProfileRef = useRef(null);

  //Function to open files
  const openFile = () => {
    document.getElementById('fileUploadImgProfile').click();
  }
  return (
    <div
      className={typeBox ? "subtitlePageHLPure-container-box" : "subtitlePageHLPure-container"}
      xs={12}
      lg={12}
      md={12}
      sm={12}
    >
      <div className="subtitlePageHLPure-subtitleImg">
        <h3 className="subtitlePageHLPure-text-title">{subtitle}</h3>
        <div
          className="subtitlePageHLPure-containerImg"
          refCustomImg={imageProfileRef}
          onClick={
            justShowImg === false ? (imageFromPc) ? openFile : () => uploadFile(imageProfileRef) : null
          }
        >
          {tooltipShow ? (
            <TooltipHLPure
              positionTooltip={positionTooltip}
              titleTooltip={titleTooltip}
              descriptionTooltip={descriptionTooltip}
              subContent={subContent}
              restContent={restContent}
              informationIcon={informationIcon}
              customImg={
                profileImg !== "" || profileImg !== null
                  ? profileImg
                  : imgProfile
              }
              refCustomImg={imageProfileRef}
              altCustomImg={altCustomImg}
              openTooltipDescription={openTooltipDescription}
              styleCustomImg={"subtitlePageHLPure-imgProfile"}
            />
          ) : (
            ""
          )}
          <div className="subtitlePageHLPure-more-elements">
            <div className="subtitlePageHLPure-more-icons">
            {
              moreIcos ? (
                moreIcos.map((icon, index) => {
                  return (
                    <React.Fragment key={String(index)}>
                      <TooltipHLPure
                        titleTooltip={icon.name}
                        descriptionTooltip={icon.description}
                        positionTooltip={icon.position}
                        customImg={icon.img}
                        styleCustomImg={"signature-detail-tooltip-img"}
                      />
                    </React.Fragment>
                  );
                }
              ))
              : null
            }
            </div>
            <div className="subtitlePageHLPure-more-icons">
              {
                textRight ? (
                  <div className="subtitlePageHLPure-container-status">
                    <p className="subtitlePageHLPure-status">
                      {subtitleRight}
                    </p>
                    <p style={{color:colorStatusContract, fontFamily: "Quicksand", fontSize: "22px", fontStyle: "normal", fontWeight: 600, textTransform:"uppercase"}}>
                      {statusContract}
                    </p>
                  </div>
                  )
                : null
              }
            </div>
          </div>
          <input
            className="subtitlePageHLPure-img"
            ref={imageProfileRef}
            type="file"
            accept=".jpg, .jpeg, .png"
            id="fileUploadImgProfile"
            name="fileUploadImgProfile"

            onChange={(e) => changeImgFile(e)}
          />
        </div>
      </div>
    </div>
  );
};

export { SubtitlePageHLPure as default };
